"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _preact = _interopRequireWildcard(require("preact"));

var _settings = require("../../constants/settings");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SocialLink = function SocialLink(_ref) {
  var id = _ref.id,
      name = _ref.name,
      url = _ref.url,
      _ref$withLabel = _ref.withLabel,
      withLabel = _ref$withLabel === void 0 ? false : _ref$withLabel,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label;
  return url ? (0, _preact.h)("a", {
    id: id,
    className: "mtn-a-social mtn-a-social--".concat(name, " ").concat(withLabel ? 'mtn-a-social--labeled' : ''),
    target: "_blank",
    href: url,
    ariaLabel: label || _settings.SOCIAL_NAMES[name]
  }, (0, _preact.h)("span", {
    className: "mtn-a-social__box"
  }, (0, _preact.h)("span", {
    className: "fa fa-".concat(_settings.SOCIAL_IMAGES[name])
  })), withLabel && (0, _preact.h)("span", {
    className: "mtn-a-social__name"
  }, label || _settings.SOCIAL_NAMES[name])) : null;
};

var _default = SocialLink;
exports["default"] = _default;